<script lang="ts" setup>
// Explicit import required: the auto-import name for components/Buttons/
// is ButtonsInternalRedirectButton, so the bare tag resolves to nothing.
import InternalRedirectButton from "~/components/Buttons/InternalRedirectButton.vue";

usePageSeo('seoServicesTitle', 'seoServicesDescription');

const services = [
  {
    title: 'Accommodation',
    description: 'accommodationIndexDescription',
    cta: 'ctaSeeSleepingOptions',
    image: 'https://res.cloudinary.com/dlct0dnwt/image/upload/v1684614497/refuge/inside/sleepingArea_1_sdpz17.jpg',
    link: '/services/accommodation'
  },
  {
    title: 'Menu',
    description: 'menuIndexDescription',
    cta: 'ctaSeeTheMenu',
    image: 'https://res.cloudinary.com/dlct0dnwt/image/upload/v1684618456/refuge/stock/food_jprilv.jpg',
    link: '/services/menu'
  }
]
</script>

<template>
  <div class="services-index-page">
    <section class="services-hero">
      <div class="hero-overlay"></div>
      <div class="hero-content">
        <h1 class="hero-title">{{ $t('Services') }}</h1>
        <p class="hero-subtitle">{{ $t('servicesSubtitle') }}</p>
      </div>
    </section>

    <div class="main-container">
      <div class="services-list">
        <div v-for="service in services" :key="service.link" class="service-card">
          <Destination 
            :refuge-img="{ link: service.image, alt: $t(service.title) }" 
            :text="$t(service.title)" 
            :link="service.link"
            :cta="null"
            class="large-card"
          />
          <div class="card-details">
            <p class="service-description">{{ $t(service.description) }}</p>
            <InternalRedirectButton 
              :redirect="service.link" 
              :text="$t(service.cta)" 
              class="discover-btn"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
.services-index-page
  width: 100%
  min-height: 100vh

.services-hero
  width: 100%
  height: 50vh
  position: relative
  background-image: url('https://res.cloudinary.com/dlct0dnwt/image/upload/v1684614474/refuge/outside/main_yjac0p.jpg')
  background-size: cover
  background-position: center
  display: flex
  align-items: center
  justify-content: center
  text-align: center
  margin-bottom: 4rem

.hero-overlay
  position: absolute
  inset: 0
  background: linear-gradient(to bottom, rgba(0,0,0,0.3), rgba(0,0,0,0.6))

.hero-content
  position: relative
  z-index: 1
  color: white

.hero-title
  font-size: clamp(3rem, 10vw, 5rem)
  font-weight: 800
  margin: 0
  text-transform: uppercase
  letter-spacing: -2px

.hero-subtitle
  font-size: 1.2rem
  opacity: 0.9
  font-weight: 500
  letter-spacing: 2px
  text-transform: uppercase

.main-container
  max-width: 1200px
  margin: 0 auto
  padding: 0 2rem 8rem
  width: 100%

.services-list
  display: flex
  gap: 2rem

// One cohesive card: image on top, description panel attached below,
// sharing a single rounded surface and shadow.
.service-card
  width: 100%
  display: flex
  flex-direction: column
  background: white
  border-radius: $border-radius-card
  overflow: hidden
  box-shadow: $shadow-modern
  transition: transform $transition-standard, box-shadow $transition-standard

  &:hover
    transform: translateY(-6px)
    box-shadow: $shadow-hover

.dark-mode .service-card
  background: $color-surface-dark

.large-card
  max-width: none !important
  width: 100% !important
  height: 500px !important
  // the card container owns the radius, shadow and hover lift now
  border-radius: 0 !important
  box-shadow: none !important

  &:hover
    transform: none !important
    box-shadow: none !important

.card-details
  display: flex
  flex-direction: column
  gap: 1.25rem
  align-items: flex-start
  text-align: left
  padding: 1.5rem 1.75rem 1.75rem

.service-description
  font-size: 1.05rem
  line-height: 1.6
  color: rgba(0, 0, 0, 0.7)
  margin: 0

.dark-mode .service-description
  color: rgba(255, 255, 255, 0.7)

.discover-btn
  height: 3rem !important

@media (max-width: 768px)
  .services-hero
    height: 40vh

  .hero-title
    font-size: clamp(1.75rem, 8.5vw, 2.5rem)

  .services-list
    flex-direction: column
</style>
